export default {"src":"/_next/static/media/smile.fc49e47d.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};